<template>
    <!-- 大步骤 -->
    <div>
        <!-- 每一步名称 -->
        <slot name="label">
            <div class="f-topic-official-more-title"
                @click="toggleStep">
                <span>{{label}}</span>
                <!-- 展开收起按钮 -->
                <span v-if="isShowStep" class="fa fa-caret-up"></span>
                <span v-else class="fa fa-caret-down"></span>
            </div>
        </slot>

        <!-- 每一步展开信息 -->
        <div v-show="isShowStep">
            <slot name="expand"></slot>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/official-process-board.less';
</style>

<script>
    export default {
        props: {
            label: String
        },
        data() {
            return {
                isShowStep: true
            };
        },
        methods: {
            toggleStep() {
                this.isShowStep = !this.isShowStep;
            }
        }
    };
</script>
